// ✅ File: frontend/src/utils/ai/costPredictor.js

export function predictTotalCost(shifts = []) {
  return shifts.reduce((total, shift) => {
    const { hourly_rate = 0, start_time, end_time, quantity = 1 } = shift;

    const duration =
      (new Date(end_time).getTime() - new Date(start_time).getTime()) /
      (1000 * 60 * 60); // in hours

    const cost = hourly_rate * duration * quantity;
    return total + (isNaN(cost) ? 0 : cost);
  }, 0);
}
